import { setPageStateById } from '../PageContext';

export const setNotFound = (setState: setPageStateById) => (notFound: boolean) => {
  setState('SET_NOT_FOUND', (s) => ({
    ...s,
    notFound,
  }));
};
